var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9202 21H3.50122C2.47722 21 1.75422 19.997 2.07822 19.0255L2.20672 18.6405C3.52872 14.675 7.23972 12 11.4202 12C14.1322 12 16.6472 13.126 18.4402 15",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4199 10C13.6291 10 15.4199 7.98528 15.4199 5.5C15.4199 3.01472 13.6291 1 11.4199 1C9.21078 1 7.41992 3.01472 7.41992 5.5C7.41992 7.98528 9.21078 10 11.4199 10Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9199 23C21.1291 23 22.9199 21.2091 22.9199 19C22.9199 16.7909 21.1291 15 18.9199 15C16.7108 15 14.9199 16.7909 14.9199 19C14.9199 21.2091 16.7108 23 18.9199 23Z",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6699 17.75L20.1699 20.25",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1699 17.75L17.6699 20.25",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAdmin);
export default __webpack_public_path__ + "static/media/addAdmin.39ac1a6253aa9e98ef935a42d0e85ad2.svg";
export { ForwardRef as ReactComponent };